module.exports = __webpack_public_path__ + "img/spain-cerebrovascular-disease-male.906f9812.png";